"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M1.166 22.3c-.901 0-1.46-.98-1.003-1.755L10.998 2.192a1.164 1.164 0 0 1 2.004 0l10.835 18.353a1.164 1.164 0 0 1-1.003 1.755H1.166Zm9.961-2.618h1.746v-1.746h-1.746v1.746Zm1.746-3.492h-1.746V9.207h1.746v6.983Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};